/**
 * SECURITY FIX (#54): Sensitive encryption keys loaded from env variables
 */
import { RESET_PASSWORD_KEY, RESET_FINGERPRINT_KEY } from '../_common/encryption-keys';

const ResetPasswordTypes = {
	/** ****************************** RESET PASSWORD *********************** */
	RESET_PASSWORD_START: 'reset_password_start',
	RESET_PASSWORD_SUCCESS: 'reset_password_success',
	RESET_PASSWORD_FAILURE: 'reset_password_failure',
	RESET_PASSWORD_RESPONSE_CHANGED: 'reset_password_response_changed',
	RESET_PASSWORD_RESPONSE_REST_START: 'reset_password_response_rest_start',
	RESET_PASSWORD_KEY: RESET_PASSWORD_KEY,
	RESET_FINGERPRINT_START: 'reset_fingerprint_start',
	RESET_FINGERPRINT_SUCCESS: 'reset_fingerprint_success',
	RESET_FINGERPRINT_FAILURE: 'reset_fingerprint_failure',
	RESET_FINGERPRINT_RESPONSE_CHANGED: 'reset_fingerprint_response_changed',
	RESET_FINGERPRINT_RESPONSE_REST_START: 'reset_fingerprint_response_rest_start',
	RESET_FINGERPRINT_KEY: RESET_FINGERPRINT_KEY,
};

export default ResetPasswordTypes;
